import { differenceWith, isEmpty, isEqual, map } from 'lodash';
import {
   AGGREGATION_DATES,
   DASHBOARD_SEARCH_CRITERIA_KEYS,
} from '../components/shared/charts-and-grids/charts-util.js';
import { getClonedObject } from './common-util.js';
import { COMMA, CRITERIA_MARKET_KEY } from './constants.js';

/**
 * category -> string STRUCTURAL|TACTICAL
 *
 * criteriaDetails -> OBJECT with below structure
 * criteriaName: {
 *      selectedValue: string
 * },
 * criteriaOperator: string (symbols),
 * criteriaValue: {
 *      selectedValues: array of string values
 * }
 *
 * whitelistedParameters: array of keys which will be part of the payload. If empty, then all keys passed will be
 * part of the payload
 */

export const queryBuilder = (
   category,
   criteriaDetails,
   whitelistedParameters
) => {
   const builtQuery = [];
   let filterQuery = '';
   let isAllSelected = false;

   const areAllSelected = (selected, all) => selected.length === all.length;
   const isFlipCondition = (selected, all) =>
      selected.length > Math.floor(all.length / 2);
   const isCriteriaMarket = (selectedCriteriaName) =>
      selectedCriteriaName === CRITERIA_MARKET_KEY;
   const isWhitelistedParameter = (selectedCriteriaName) =>
      whitelistedParameters.indexOf(selectedCriteriaName) > -1;

   map(criteriaDetails.filterBy, (eachCriteria) => {
      const criteriaName = eachCriteria.criteriaName;
      let criteriaOperator = eachCriteria.criteriaOperator;
      const criteriaValue = eachCriteria.criteriaValue;

      if (
         areAllSelected(criteriaValue.selectedValues, criteriaValue.allOptions)
      ) {
         isAllSelected = true;
      } else if (isWhitelistedParameter(criteriaName.selectedValue)) {
         const marketRule = [];
         let selectedCriteriaValues = getClonedObject(
            criteriaValue.selectedValues
         );
         const isFlip = isFlipCondition(
            selectedCriteriaValues,
            criteriaValue.allOptions
         );
         if (isFlip) {
            selectedCriteriaValues = differenceWith(
               criteriaValue.allOptions,
               selectedCriteriaValues,
               isEqual
            );
         }

         if (isCriteriaMarket(criteriaName.selectedValue)) {
            if (isFlip) {
               criteriaOperator = criteriaOperator === '==' ? '!=' : '==';
            }
            map(selectedCriteriaValues, (eachOrgDest) => {
               const orgDest = eachOrgDest.value.split('-');
               marketRule.push(
                  `(origin${criteriaOperator}'${orgDest[0]}';destination${criteriaOperator}'${orgDest[1]}')`
               );
            });

            if (!isEmpty(marketRule)) {
               builtQuery.push(`((${marketRule.join(COMMA)}))`);
            }
         } else {
            criteriaOperator =
               criteriaOperator === '=='
                  ? isFlip
                     ? '=out='
                     : '=in='
                  : isFlip
                  ? '=in='
                  : '=out=';

            map(selectedCriteriaValues, (eachCriteriaValue) =>
               marketRule.push(`'${eachCriteriaValue.value}'`)
            );

            if (!isEmpty(marketRule)) {
               builtQuery.push(
                  `(((${
                     criteriaName.selectedValue
                  }${criteriaOperator}(${marketRule.join(COMMA)}))))`
               );
            }
         }
      }
   });

   filterQuery = isEmpty(builtQuery) ? '' : `${builtQuery.join(';')};`;
   filterQuery +=
      isEmpty(filterQuery) && !isAllSelected
         ? ''
         : `(((aggregationDate>='${
              criteriaDetails[
                 DASHBOARD_SEARCH_CRITERIA_KEYS.CRITERIA_AGGREGATION_DATE
              ][AGGREGATION_DATES.AGGREGATION_FROM_DATE]
           }';aggregationDate<='${
              criteriaDetails[
                 DASHBOARD_SEARCH_CRITERIA_KEYS.CRITERIA_AGGREGATION_DATE
              ][AGGREGATION_DATES.AGGREGATION_TO_DATE]
           }')));`;

   return isEmpty(filterQuery)
      ? null
      : `filter=${filterQuery}(((category=='${category}')))&pageLimit=-1`;
};
